{
  "major": 7,
  "minor": 5,
  "patch": 6,
  "build": 11,
  "notes": "",
  "date": ""
}
